import {Icon, ThemeIconKey} from 'platform/foundation';
import {css, useTheme} from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface NavigationButtonProps extends TestIdProps {
  icon: ThemeIconKey;
  onClick?: () => void;
  isDisabled?: boolean;
  'aria-label'?: string;
}

export function NavigationButton(props: NavigationButtonProps) {
  const theme = useTheme();

  return (
    <button
      aria-label={props['aria-label']}
      data-testid={suffixTestId('navigationButton', props)}
      disabled={props.isDisabled}
      onClick={props.onClick}
      type="button"
      css={css`
        align-items: center;
        background: ${theme.colors.general.white};
        border-radius: ${theme.radii.small};
        border: none;
        box-shadow: ${theme.shadows.elevation_2};
        cursor: ${props.isDisabled ? 'not-allowed' : 'pointer'};
        display: flex;
        justify-content: center;
        opacity: ${props.isDisabled ? 0.4 : 1};
        padding: ${theme.getSize(2)};
        transition: background-color 0.2s ease-in-out;

        &:hover:not(:disabled) {
          background: ${theme.colors.palettes.neutral['10']['100']};
        }

        &:active:not(:disabled) {
          background: ${theme.colors.palettes.neutral['20']['100']};
        }
      `}
    >
      <Icon value={props.icon} color="palettes.neutral.800.100" size={4} />
    </button>
  );
}
